module.exports = __webpack_public_path__ + "img/avatar@3x.b6d5a481.png";